import { observable, set } from 'mobx';

export interface IDCInventory {
    productId: string;
    skuId: string;
    status: string;
}

export class DCInventory implements IDCInventory {
    @observable public skuId: string;
    @observable public productId: string;
    @observable status: string;

    public static fromJson(data: IDCInventory): DCInventory {
        const inventory = new DCInventory();
        set(inventory, data);

        return inventory;
    }
}
